import { Routes, Route } from "react-router-dom";
import LandingPage from "../components/LandingPage";
import ProductsPage from "../components/ProductsPage";
import CartPage from "../components/CartPage";
import CheckoutPage from "../components/CheckoutPage";
import AccountPage from "../components/AccountPage";
import SearchResultsPage from "../components/SearchResultsPage";
import ProductDetailPage from "../components/ProductDetailPage";
import HomeProductDetailPage from "../components/HomeProductDetailPage";
import AdminPage from "../components/AdminPage";
import SettingsPage from "../components/SettingsPage";
import ProductRecommendationPage from "../components/ProductRecommendationPage";
import WishlistPage from "../components/WishlistPage";
import { Box } from "@mui/material";
import OrderConfirmationPage from "../components/OrderConfirmationPage";
import OrderHistoryPage from "../components/OrderHistoryPage";
import AccessoriesPage from "../components/AccessoriesPage";
import SalePage from "../components/SalePage";
import NewArrivalsPage from "../components/NewArrivalsPage";
import WomenPage from "../components/WomenPage";
import MenPage from "../components/MenPage";
import DidAvatarCode from "../components/NewaVatarCode/DidAvatarCode";
import HeygenAvatar from "../HeygenAvatar/HeygenAvatar";
/**
 * Application Routes Configuration
 * All routes are defined here for better organization and maintainability
 * 
 * This component contains all the route mappings
 */
export const AppRoutes = () => {
  return (
    <Box sx={{ mt: 1}}>   {/* <-- ADDED WRAPPER HERE */}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/search" element={<SearchResultsPage />} />
        <Route path="/product/:id" element={<ProductDetailPage />} />
        <Route path="/item/:id" element={<HomeProductDetailPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/recommendations" element={<ProductRecommendationPage />} />
        <Route path="/wishlist" element={<WishlistPage />} />
        <Route path="/order-confirmation" element={<OrderConfirmationPage />} />
        <Route path="/order-history" element={<OrderHistoryPage />} />
        <Route path="/accessories" element={<AccessoriesPage />} />
        <Route path="/sale" element={<SalePage />} />
        <Route path="/new-arrivals" element={<NewArrivalsPage />} />
        <Route path="/women" element={<WomenPage />} />
        <Route path="/men" element={<MenPage />} />
        <Route path="/avatar" element={<DidAvatarCode />} />
        <Route path="/heygen-avatar" element={<HeygenAvatar />} />
      </Routes>
    </Box>
  );
};
